module.exports = __webpack_public_path__ + "img/three-dots-slate.dfbbaf60.svg";